import { render } from "./SectsIndexView.vue?vue&type=template&id=55d21426"
import script from "./SectsIndexView.vue?vue&type=script&lang=js"
export * from "./SectsIndexView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__